module.exports = {
	"articleTitle1": "Cafe Zola offers a unique brunch in Ann Arbor ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Cafe Zola",
	"articleLink1": "https://www.michigandaily.com/section/news/cafe-zola-unique-brunch-ann-arbor",
	"articleLink2": "https://www.michigandaily.com/arts/10secondary-cafe-zola-kelly24",
	"articleSnippet1": "Mar 17, 2016 ... Walking into Café Zola, the atmosphere is unlike other brunch spots in Ann Arbor \n— and that's just what they're going for.",
	"articleSnippet2": "Oct 24, 2013 ... Café Zola has something to offer even the pickiest of brunch-munchers. The \ndiverse menu complimented by fresh ingredients and friendly ...",
	"foodRecommendations": [],
	"articleTitle2": "Café Zola finds a recipe for successful brunch",
	"address": "112 W Washington St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160318/msh.NEW_.BreakfastSeries.3.17.16429.jpg?itok=_E0Yi7ob",
			"author": "Mazie Hyams",
			"caption": "The Turkish brunch at Cafe Zola."
		}
	],
	"position": {
		"lat": 42.280688,
		"lng": -83.749263
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cafezola.json
// module id = 841
// module chunks = 0